/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';

import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Checkbox,
    Skeleton,
    TableContainer,
    FormControl,
    Select,
    MenuItem,

} from '@mui/material';

const projects = [
    {
        dpath: 'https://randomuser.me/api/portraits/women/68.jpg',
        name: 'Vansh Saini',
        desk: 'Social Media Strategist',
    },
    {
        dpath: 'https://randomuser.me/api/portraits/men/32.jpg',
        name: 'Devon Lane',
        desk: 'Social Media Strategist',
    },
    {
        dpath: 'https://randomuser.me/api/portraits/women/44.jpg',
        name: 'Leslie Alexander',
        desk: 'Social Media Strategist',
    },
];


const CustomCheckbox = ({ checked, onChange }) => (
    <Checkbox
        checked={checked}
        onChange={onChange}
        icon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    border: '1px solid #D0D5DD',
                    backgroundColor: '#E5E8EB',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
        checkedIcon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    backgroundColor: '#1976d2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
    />
);

const WorkData = () => {
    const [loading, setLoading] = useState(true);
    const [selectedValues, setSelectedValues] = useState([]);
    const [dropdownValues, setDropdownValues] = useState('');

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    const handleCheckboxChange = (name) => {
        setSelectedValues((prev) =>
            prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
        );
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedValues(projects.map((p) => p.name));
        } else {
            setSelectedValues([]);
        }
    };
    const memberImgList = [
        {
            imgeOne: '/assets/images/img1.png'
        },
        {
            imgeOne: '/assets/images/img2.png'
        },
        {
            imgeOne: '/assets/images/img3.png'
        },
        {
            imgeOne: '/assets/images/img1.png'
        },
        {
            imgeOne: '/assets/images/img1.png'
        },
    ]
    const actionDropDown = [
        {
            option: 'Edit policies'
        },
       
        {
            option: 'Remove'
        }
    ]

      const handleChangeUser = (event, index) => {
        const updatedRoles = [...rolesState];
        updatedRoles[index] = event.target.value;
        setRolesState(updatedRoles);
    };


    const [rolesState, setRolesState] = useState(
        projects.map(() => "")   // initialize for each row
    );
    return (
        <div>
            <TableContainer sx={{ boxShadow: 'none' }}>
                <Table className='shadow-none' sx={{ boxShadow: 'none', borderCollapse: 'separate', }}>
                    <TableHead>
                        <TableRow sx={{
                            backgroundColor: '#DFDFDF',
                            '& th:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                            '& th:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                        }}>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px' }} padding="checkbox">
                                <CustomCheckbox
                                    checked={projects.length > 0 && selectedValues.length === projects.length}
                                    onChange={handleSelectAll}
                                />
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>#</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Policy Name</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}> Members</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Type</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#fff' }}>

                        {loading

                            ? [...Array(4)].map((_, i) => (

                                <TableRow key={i}>
                                    {[...Array(6)].map((_, j) => (
                                        <TableCell key={j}><Skeleton variant="text" /></TableCell>
                                    ))}
                                </TableRow>
                            ))

                            : projects.map((project, index) => (

                                <TableRow key={index} sx={{
                                    borderRadius: '8px',
                                    '& td:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                                    '& td:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                                }}>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }} padding="checkbox">
                                        <CustomCheckbox
                                            checked={selectedValues.includes(project.name)}
                                            onChange={() => handleCheckboxChange(project.name)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px', fontFamily: 'Manrope' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Box>
                                                <Typography sx={{ fontSize: '14px', color: '#1760EC', fontWeight: '500', fontFamily: 'Manrope' }}>
                                                    {project.name}
                                                </Typography>

                                            </Box>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>

                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            {memberImgList.slice(0, 3).map((curElem, index) => (
                                                <Box key={index} sx={{ marginLeft: index === 0 ? '0px' : '-10px' }}>
                                                    <img
                                                        src={curElem.imgeOne}
                                                        alt={`member-${index}`}
                                                        style={{ width: '34px', height: '34px', borderRadius: '40px' }}
                                                    />
                                                </Box>
                                            ))}

                                            {memberImgList.length > 3 && (
                                                <Box
                                                    sx={{
                                                        background: '#EAF0FF',
                                                        width: '34px',
                                                        height: '34px',
                                                        borderRadius: '40px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        marginLeft: '-10px',
                                                    }}
                                                >
                                                    <Typography sx={{ color: '#7B7E8B', fontSize: '14px', fontWeight: '600' }}>
                                                        +{memberImgList.length - 3}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                         <Typography sx={{ color: '#373737', fontSize: '15px', fontWeight: '400', fontFamily: 'Manrope' }}>
                                                     Paid
                                                    </Typography>

                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <Box display="flex" justifyContent="end">
                                            <Box sx={{ width: 200 }}>
                                                <FormControl fullWidth variant="outlined" size="small">
                                                    <Select
                                                      value={rolesState[index]}
                                                        onChange={(event) => handleChangeUser(event, index)}
                                                        displayEmpty
                                                        renderValue={(select) => {
                                                            if (!select) {
                                                                return <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>Action</Typography>;
                                                            }
                                                            return <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{select}</Typography>;
                                                        }}
                                                        sx={{ backgroundColor: 'white', fontFamily: 'Manrope', fontSize: '14px', color: '#64748B', borderRadius: '100px' }}>
                                                        {
                                                            actionDropDown.map((curElem => (
                                                                <MenuItem value={curElem.option}>
                                                                    <Box>
                                                                        <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{curElem.option}</Typography>
                                                                    </Box>
                                                                </MenuItem>
                                                            )))
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </Box>

                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>

                </Table>
            </TableContainer>

        </div>
    )
}

export default WorkData
